"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Display = exports.DisplayPrimitive = exports.DisplayArray = exports.DisplayObject = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const TypeUtils_1 = require("../../../common/TypeParsing/TypeUtils");
const Layout_1 = require("./Layout");
const HelperTypes_1 = require("./HelperTypes");
const DisplayBase = (0, styled_components_1.default)(Layout_1.LayoutBox) `
  flex: 1 1 auto;
  overflow: hidden;
`;
const DisplayObjectBase = (0, styled_components_1.default)(DisplayBase) ``;
const DisplayArrayBase = (0, styled_components_1.default)(DisplayBase) ``;
const DisplayPrimitiveBase = (0, styled_components_1.default)(DisplayBase) ``;
const DisplayObject = (_a) => {
    var { typeStructure, typeStructureMap, value = {} } = _a, elementProps = __rest(_a, ["typeStructure", "typeStructureMap", "value"]);
    const { name = "", content = [] } = typeStructure;
    const displayLayout = (0, react_1.useMemo)(() => {
        const dL = (0, TypeUtils_1.getTagValue)(TypeUtils_1.TAG_TYPES.displayLayout, typeStructure);
        return typeof dL === "string"
            ? (0, Layout_1.getTypeStructureLayoutGridTemplate)(dL)
            : undefined;
    }, [typeStructure]);
    return ((0, jsx_runtime_1.jsx)(DisplayObjectBase, Object.assign({ className: `display-object-${name}`, "$isGrid": !!displayLayout, "$gridTemplate": displayLayout, "$gridArea": name }, elementProps, { children: content.map((item, index) => {
            const { name } = item;
            return ((0, jsx_runtime_1.jsx)(exports.Display, { typeStructure: item, typeStructureMap: typeStructureMap, value: value[name] }, index));
        }) })));
};
exports.DisplayObject = DisplayObject;
const DisplayArray = (_a) => {
    var { typeStructure, typeStructureMap, value = [] } = _a, elementProps = __rest(_a, ["typeStructure", "typeStructureMap", "value"]);
    const { name = "" } = typeStructure;
    return ((0, jsx_runtime_1.jsx)(DisplayArrayBase, Object.assign({ className: `display-array-${name}`, "$gridArea": name }, elementProps, { children: value.map((item, index) => ((0, jsx_runtime_1.jsx)(exports.Display, { typeStructure: typeStructure, typeStructureMap: typeStructureMap, value: item, isItem: true }, index))) })));
};
exports.DisplayArray = DisplayArray;
const DisplayPrimitive = (_a) => {
    var { typeStructure, typeStructureMap, value } = _a, elementProps = __rest(_a, ["typeStructure", "typeStructureMap", "value"]);
    const { name = "" } = typeStructure;
    return ((0, jsx_runtime_1.jsx)(DisplayPrimitiveBase, Object.assign({ className: `display-primitive-${name}`, "$gridArea": name }, elementProps, { children: value })));
};
exports.DisplayPrimitive = DisplayPrimitive;
const Display = (_a) => {
    var { typeStructure, typeStructureMap, value, isItem = false } = _a, elementProps = __rest(_a, ["typeStructure", "typeStructureMap", "value", "isItem"]);
    const cleanTypeStructure = (0, react_1.useMemo)(() => {
        const { name } = typeStructure;
        const tS = (0, TypeUtils_1.getTypeStructureByPath)([name], typeStructure, typeStructureMap);
        return (0, TypeUtils_1.getMergedTypeStructure)(tS, typeStructure) || tS;
    }, [typeStructure]);
    const { type, multiple = false } = cleanTypeStructure;
    const typeStructureIsPrimitive = (0, react_1.useMemo)(() => type in HelperTypes_1.DataTypeMap || (0, TypeUtils_1.getTypeStructureIsPrimitive)(cleanTypeStructure), [type, cleanTypeStructure]);
    return multiple && !isItem ? ((0, jsx_runtime_1.jsx)(exports.DisplayArray, Object.assign({ typeStructure: cleanTypeStructure, typeStructureMap: typeStructureMap, value: value }, elementProps))) : typeStructureIsPrimitive ? ((0, jsx_runtime_1.jsx)(exports.DisplayPrimitive, Object.assign({ typeStructure: cleanTypeStructure, typeStructureMap: typeStructureMap, value: value }, elementProps))) : ((0, jsx_runtime_1.jsx)(exports.DisplayObject, Object.assign({ typeStructure: cleanTypeStructure, typeStructureMap: typeStructureMap, value: value }, elementProps)));
};
exports.Display = Display;
